import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { HeadingButton } from '../accordion/styles';

export const VideoContainer = styled.div``;

export const TextContainer = styled.div``;

export const Title = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const BottomText = styled.div`
  margin-top: ${({ theme }) => theme.spacing.standard};

  p:last-child {
    margin-bottom: 0;
  }
`;

export const Transcript = styled.div`
  margin-top: ${({ theme }) => theme.spacing.standard};
  background-color: ${({ theme }) => theme.palette.white};

  /* TODO: These styles overwrite the default accordion component styles.
    It should be revisited once the rebrand work is merged into master. */
  ${HeadingButton} {
    font-size: ${({ theme }) => theme.fontsize.mobile.h4};
    font-weight: 700;

    ${breakpoint.tablet`
      font-size: ${({ theme }) => theme.fontsize.h4};
    `};
  }
`;

export const Wrapper = styled.div`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};

  ${({ $fullWidth }) =>
    !$fullWidth &&
    // Non fullWidth / text aside variant
    css`
      display: flex;
      flex-wrap: wrap;

      ${VideoContainer} {
        ${breakpoint.tablet`
          width: 60%;
        `};
      }

      ${TextContainer} {
        padding: 0 16px;
        ${breakpoint.tablet`
          width: 40%;
        `};
      }

      ${Title} {
        margin-bottom: 12px;
      }

      ${BottomText} {
        margin-top: 12px;
      }

      ${Transcript} {
        flex-basis: 100%;
      }
    `};
`;

export const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
